export const ShowAllJobs = 'job-show-all';
export const ShowAllJobRequests = 'job-requests-show-all';
export const ReviewJobRequest = 'job-requests-review';
export const ViewAllServiceTypes = 'service-types-view';
export const ViewApprovalsDashboard = 'show-job-approve-dashboard';
export const ViewBillingDashboard = 'show-billing-dashboard';
export const ViewCustomersDashboard = 'customers-view';
export const EditCustomer = 'edit-customers';
export const CreateCustomer = 'create-customers';
export const ShowJobActions = 'show-job-actions';
export const ShowConfiguration = 'show-configuration';
export const ShowOperations = 'show-operations';
export const ManageAssociations = 'manage-associations';
export const CreateJob = 'job-create';
export const CreateJobWithBilling = 'job-create-with-billing';
export const ConfirmBilling = 'confirm-billing';
export const ViewPriceLists = 'price-lists-view';

// composite roles
export const Admin = 'admin';
export const Billing = 'billing';
export const Director = 'director';
export const Dispatch = 'dispatch';
export const Lead = 'lead';
export const Manager = 'manager';

export type Role =
  | typeof Admin
  | typeof Billing
  | typeof Director
  | typeof Dispatch
  | typeof Lead
  | typeof Manager
  | typeof ShowAllJobs
  | typeof ShowAllJobRequests
  | typeof ViewApprovalsDashboard
  | typeof ReviewJobRequest
  | typeof ViewAllServiceTypes
  | typeof ViewBillingDashboard
  | typeof ViewCustomersDashboard
  | typeof EditCustomer
  | typeof ShowJobActions
  | typeof CreateCustomer
  | typeof ShowConfiguration
  | typeof ShowOperations
  | typeof ManageAssociations
  | typeof CreateJob
  | typeof CreateJobWithBilling
  | typeof ConfirmBilling
  | typeof ViewPriceLists;
